export interface Messages {
  [key: string]: string;
}

export type Translator = (key: string) => string;

export const createTranslator = (messages?: Messages): Translator => {
  return (key: string) => (messages && messages[key]) || key;
};
